import { render, staticRenderFns } from "./TopicSearch.vue?vue&type=template&id=5575a54f&"
import script from "./TopicSearch.vue?vue&type=script&lang=ts&"
export * from "./TopicSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports